import { useMediaQuery, useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface ConditionalDisplayProps {
    children: ReactNode;
}

export const HiddenMdDown = ({ children }: ConditionalDisplayProps) => {
    const theme = useTheme();
    const mdUp = useMediaQuery(theme.breakpoints.up('md'));
    return mdUp ? <>{children}</> : null;
};

export const HiddenMdUp = ({ children }: ConditionalDisplayProps) => {
    const theme = useTheme();
    const mdDown = useMediaQuery(theme.breakpoints.down('md'));
    return mdDown ? <>{children}</> : null;
};

export const HiddenSmDown = ({ children }: ConditionalDisplayProps) => {
    const theme = useTheme();
    const smUp = useMediaQuery(theme.breakpoints.up('sm'));
    return smUp ? <>{children}</> : null;
};

export const HiddenSmUp = ({ children }: ConditionalDisplayProps) => {
    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));
    return smDown ? <>{children}</> : null;
};

export const HiddenLgDown = ({ children }: ConditionalDisplayProps) => {
    const theme = useTheme();
    const lgUp = useMediaQuery(theme.breakpoints.up('lg'));
    return lgUp ? <>{children}</> : null;
};

export const HiddenLgUp = ({ children }: ConditionalDisplayProps) => {
    const theme = useTheme();
    const lgDown = useMediaQuery(theme.breakpoints.down('lg'));
    return lgDown ? <>{children}</> : null;
};

export const HiddenXlDown = ({ children }: ConditionalDisplayProps) => {
    const theme = useTheme();
    const xlUp = useMediaQuery(theme.breakpoints.up('xl'));
    return xlUp ? <>{children}</> : null;
};

export const HiddenXlUp = ({ children }: ConditionalDisplayProps) => {
    const theme = useTheme();
    const xlDown = useMediaQuery(theme.breakpoints.down('xl'));
    return xlDown ? <>{children}</> : null;
};

export const HiddenXsDown = ({ children }: ConditionalDisplayProps) => {
    const theme = useTheme();
    const xsUp = useMediaQuery(theme.breakpoints.up('xs'));
    return xsUp ? <>{children}</> : null;
};

export const HiddenXsUp = ({ children }: ConditionalDisplayProps) => {
    const theme = useTheme();
    const xsDown = useMediaQuery(theme.breakpoints.down('xs'));
    return xsDown ? <>{children}</> : null;
};
